export default __webpack_public_path__ + "static/media/home@2x.3ead42ec.png";